import React, { useState, useEffect } from "react";
import {
    Card,
    CardContent,
    CardHeader,
    Button,
    Divider,
    Box,
    Tooltip,
    IconButton,
    CircularProgress,
    Typography,
} from "@mui/material";
import { GridToolbar } from "@mui/x-data-grid";
import { DataGrid } from "@mui/x-data-grid";
import clsx from "clsx";
import axios from "axios";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { Download } from "@mui/icons-material";
const base = "https://";

const UploadFiles = () => {
    const [tabledata, setTabledata] = useState([]);
    const [loading, setLoading] = useState(false);

    const HoverCell = ({ value }) => {
        return (
            <Tooltip title={value}>
                <div style={{ whiteSpace: "normal", textAlign: "start" }}>{value}</div>
            </Tooltip>
        );
    };

    const columns = [
        { field: "sr.no", headerName: "Sr.no", width: 70 },
        { field: "id", headerName: "LogId", width: 130 },
        {
            field: "file_name",
            headerName: "Files Name",
            width: 200,
            wrapText: true,
            align: "left",
            renderCell: (params) => {
                return <HoverCell value={params.value} />;
            },
        },
        {
            field: "created_at",
            headerName: "Date",
            width: 230,
            renderCell: (params) => {
                return <HoverCell value={params.value} />;
            },
        },
        {
            field: "status",
            headerName: "Status",
            width: 110,
            cellClassName: (params) => {
                if (params.value == null) {
                    return "";
                }
                return clsx("super-app", {
                    positive: params.value === "Success",
                    negative: params.value === "Error",
                    partial: params.value === "Partial Success",
                    processing: params.value === "Processing",
                });
            },
        },
        {
            field: "offer_type",
            headerName: "Offer Type",
            width: 200,
        },
        {
            field: "count",
            headerName: "No of records processed",
            width: 150,
        },
        {
            field: "current_status",
            headerName: "Progress",
            width: 150,
            cellClassName: (params) => {
                if (params.value == null) {
                    return "";
                }
                return clsx("super-app", {
                    positive: params.value === "Success",
                    negative: params.value === "Error",
                    partial: params.value === "Partial Success",
                    processing: params.value === "Processing",
                });
            },
        },
        {
            field: "process_log",
            headerName: "Process Log",
            width: 120,
            align: "center",
            renderCell: (params) => (
                <IconButton
                    aria-label="Download"
                    onClick={() => downloadDraftInvoiceFile(params.row.id)}
                >
                    <Download color={"primary"} />
                </IconButton>
            ),
        },
    ];

    const handleUploadData = async () => {
        try {
            setLoading(true);
            const response = await axios.post(
                base +
                "api.more.in/v1/ssp_offers",
                {
                    rawPath: "/process_logs"
                },
                {
                    headers: {
                        authorization: Cookies.get("ssp_sso_token"),
                        "content-type": "application/json",
                    },
                }
            );
            if (response?.data?.body?.data) {
                const rowsData = response?.data?.body?.data
                    ?.map((row) => ({
                        ...row,
                    }))
                    .sort((a, b) => b.id - a.id) // Sort descending by logid
                    .map((row, index) => ({
                        ...row,
                        "sr.no": index + 1, // Assign serial number after sorting
                    }));
                setTabledata(rowsData);
                setLoading(false);
            } else {
                toast.error(response?.data?.body?.message || "Fetch data failed", {
                    position: "top-right",
                });
                setLoading(false);
                return;
            }
        } catch (err) {
            console.log(err);
            setLoading(false);
            toast.error("Something went wrong", { position: "top-right" });
        }
    };

    const downloadDraftInvoiceFile = async (logid) => {
        try {
            setLoading(true);
            const response = await axios.post(
                base +
                "api.more.in/v1/ssp_offers",
                { log_id: logid, rawPath: "/download_process_logs" },
                {
                    headers: {
                        authorization: Cookies.get("ssp_sso_token"),
                        "content-type": "application/json",
                    },
                }
            );
            if (response?.data?.status === "success") {
                setLoading(false);
                window.open(response?.data?.body?.data, "_blank");
            } else {
                toast.error(
                    response?.data?.body?.message ||
                    "Process log download failed. Please try again later",
                    { position: "top-right" }
                );
                setLoading(false);
                return;
            }
        } catch (err) {
            console.log(err);
            toast.error("Something went wrong. Please try again later", {
                position: "top-right",
            });
            setLoading(false);
        }
    };

    useEffect(() => {
        handleUploadData();
    }, []);

    return (
        <>
            <Card
                sx={{
                    mt: 3,
                    width: "90%",
                    mx: "auto",
                    backgroundColor: "#FFFFFF",
                    boxShadow: 3,
                    borderRadius: 2,
                    marginBottom: 2,
                }}
            >
                <CardHeader
                    p={2}
                    sx={{
                        backgroundColor: "#F8F8F9",
                        borderTopRightRadius: "5px",
                        borderTopLeftRadius: "5px",
                        fontWeight: "bold",
                        fontSize: "1.1rem",
                    }}
                    title={"Uploaded Files"}
                    titleTypographyProps={{
                        sx: {
                            fontSize: "16px",
                            fontWeight: "600",
                            lineHeight: "16px",
                            color: "#0160F1",
                        },
                    }}
                    action={
                        <>
                            <Button onClick={() => window.location.reload()}>
                                Refresh Page
                            </Button>
                        </>
                    }
                />
                <Divider />
                {loading && (
                    <Box
                        sx={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            zIndex: 9999,
                        }}
                    >
                        <CircularProgress color="primary" size={60} />
                        <Typography
                            variant="h6"
                            sx={{ color: "#fff", mt: 2, fontWeight: 500 }}
                        >
                            Loading...
                        </Typography>
                    </Box>
                )}
                <CardContent
                    sx={{
                        backgroundColor: "#FFFFFF",
                        borderBottomRightRadius: "5px",
                        borderBottomLeftRadius: "5px",
                    }}
                >
                    <Box
                        sx={{
                            height: 500,
                            width: "100%",
                            "& .super-app.positive": {
                                color: "rgb(4,171,105)",

                                fontWeight: "600",
                            },
                            "& .super-app.negative": {
                                color: "rgb(234,39,21)",

                                fontWeight: "600",
                            },
                            "& .super-app.partial": {
                                color: "rgb(244,161,0)",

                                fontWeight: "600",
                            },
                            "& .super-app.progressdata": {
                                color: "rgb(4,171,105)",

                                fontWeight: "600",
                            },
                            "& .super-app.progressdatafail": {
                                color: "rgb(234,39,21)",

                                fontWeight: "600",
                            },
                            "& .super-app.progressdatapartial": {
                                color: "rgb(244,161,0)",

                                fontWeight: "600",
                            },
                            "& .super-app.processing": {
                                color: "rgb(104,112,122)",

                                fontWeight: "600",
                            },
                            "& .super-app.pending": {
                                color: "rgb(3,95,240)",

                                fontWeight: "600",
                            },
                        }}
                    >
                        <DataGrid
                            rowHeight={80}
                            showCellRightBorder={true}
                            sx={{
                                ".MuiDataGrid-columnHeaderTitle": {
                                    fontWeight: "bold !important",
                                },
                                overflowX: "scroll",
                            }}
                            rows={tabledata}
                            columns={columns}
                            headerClassName="header-center"
                            rowsPerPageOptions={[10]}
                            pageSize={10}
                            getRowId={(row) => row.id}
                            components={{
                                Toolbar: GridToolbar,
                            }}
                            componentsProps={{
                                toolbar: {
                                    showQuickFilter: true,
                                    quickFilterProps: { debounceMs: 500 },
                                },
                            }}
                        />
                    </Box>
                </CardContent>
            </Card>
        </>
    );
};

export default UploadFiles;
